import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { Tax } from 'src/app/domain/models/tax.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TaxService {
  constructor(private http: HttpClient) { }

  get(countryId: number, finalityId: number, currency: string) {
    return this.http.get<ResponseObjectModel<Tax>>(
      `${environment.API_BASE_URL}/v1/tax?countryId=${countryId}&finalityId=${finalityId}&currency=${currency}`
    );
  }

   getXaviPayTax(countryId: number, finalityId: number, currency: string) {
    return this.http.get<ResponseObjectModel<Tax>>(
      `${environment.API_BASE_URL}/v1/tax/xavi-pay?countryId=${countryId}&finalityId=${finalityId}&currency=${currency}`
    );
  }


  getByCorporateAccount(corporateAccountId: number) {
    return this.http.get<ResponseObjectModel<Tax>>(
      `${environment.API_BASE_URL}/v1/corporate-accounts/${corporateAccountId}/tax`
    );
  }
}
